import React from "react";
import { Card } from "react-bootstrap";
import "./Services.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPaintBrush,
  faCogs,
  faLaptopCode,
} from "@fortawesome/free-solid-svg-icons";
import Rotate from "react-reveal/Rotate";
import Slide from "react-reveal/Slide";
import Zoom from "react-reveal/Zoom";
const Services = () => {
  return (
    <div className="services">
      <h1 className="service-title text-center" id="Services">
        My Servi<span style={{ color: "crimson" }}>ces</span>
      </h1>
      <div className="container service-body pb-5">
        <div className="row d-flex justify-content-center">
          <Card className="col-md-3 ml-4 cart" style={{ width: "18rem" }}>
            <Rotate>
              <div className="service-icons">
                <FontAwesomeIcon className="service-icon" icon={faPaintBrush} />
              </div>
              <Card.Body>
                <Card.Title className="text-center">Front End</Card.Title>
                <Card.Text>
                  Some quick example text to build on the card title and make up
                  the bulk of the card's content.
                </Card.Text>
              </Card.Body>
            </Rotate>
          </Card>
          <Card className="col-md-3 ml-4 cart" style={{ width: "18rem" }}>
            <Slide right>
              <div className="service-icons">
                <FontAwesomeIcon className="service-icon" icon={faCogs} />
              </div>
              <Card.Body>
                <Card.Title className="text-center">Back End</Card.Title>
                <Card.Text>
                  Some quick example text to build on the card title and make up
                  the bulk of the card's content.
                </Card.Text>
              </Card.Body>
            </Slide>
          </Card>
          <Card className="col-md-3 ml-4 cart" style={{ width: "18rem" }}>
            <Zoom left>
              <div className="service-icons">
                <FontAwesomeIcon className="service-icon" icon={faLaptopCode} />
              </div>
              <Card.Body>
                <Card.Title className="text-center">Full Stack</Card.Title>
                <Card.Text>
                  Some quick example text to build on the card title and make up
                  the bulk of the card's content.
                </Card.Text>
              </Card.Body>
            </Zoom>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Services;
